import { useEffect, useState } from "react";

const getBool = (k, def = false) => {
  try {
    const v = localStorage.getItem(k);
    if (!v) return def;
    const s = v.toLowerCase();
    return s === "1" || s === "true" || s === "yes" || s === "on";
  } catch {
    return def;
  }
};

export default function useGeneralSettings() {
  const [showInterpretedPreview, setShowInterpretedPreview] = useState(true);
  const [requireCmdEnterToSearch, setRequireCmdEnterToSearch] = useState(false);
  const [showDocPreview, setShowDocPreview] = useState(true);
  const [savedFlag, setSavedFlag] = useState(false);

  useEffect(() => {
    setShowInterpretedPreview(getBool("pref_show_interpreted", true));
    setRequireCmdEnterToSearch(getBool("pref_cmdenter_to_search", false));
    setShowDocPreview(getBool("pref_show_doc_preview", true));
  }, []);

  const save = () => {
    try {
      localStorage.setItem(
        "pref_show_interpreted",
        showInterpretedPreview ? "true" : "false"
      );
      localStorage.setItem(
        "pref_cmdenter_to_search",
        requireCmdEnterToSearch ? "true" : "false"
      );
      localStorage.setItem(
        "pref_show_doc_preview",
        showDocPreview ? "true" : "false"
      );
      setSavedFlag(true);
      setTimeout(() => setSavedFlag(false), 1500);
    } catch {}
  };

  const reset = () => {
    setShowInterpretedPreview(true);
    setRequireCmdEnterToSearch(false);
    setShowDocPreview(true);
  };

  return {
    showInterpretedPreview,
    setShowInterpretedPreview,
    requireCmdEnterToSearch,
    setRequireCmdEnterToSearch,
    showDocPreview,
    setShowDocPreview,
    savedFlag,
    save,
    reset,
  };
}
